<template>
    <div>
        <div class="vx-row">
            <vs-card>
                <div slot="header">
                    <h5>Statistique des demandes</h5>
                </div>
                <vs-row>
                    <vs-col>
                        <div class="flex -mx-2">
                            <div class="w-1/4 px-2">
                                <vs-select
                                    v-model="category"
                                    placeholder="Selectionner"
                                    class="w-full"
                                    label="Type de demande"
                                    label-placeholder="Selectionner"
                                    autocomplete
                                >
                                    <vs-select-item :key="index" :value="item.id" :text="item.name" v-for="(item,index) in categories"/>
                                </vs-select>
                            </div>
                            <div class="w-1/4 px-2">
                                <span class="vs-select--label">Période</span>
                                <date-range-picker
                                    ref="picker"
                                    :opens="opens"
                                    :locale-data=locale
                                    :singleDatePicker="false"
                                    :timePicker=false
                                    :showWeekNumbers="showWeekNumbers"
                                    :showDropdowns="showDropdowns"
                                    :autoApply="autoApply"
                                    v-model="dateRange"
                                    :ranges=false
                                    @update="updateValues"
                                    :linkedCalendars="linkedCalendars"
                                    :dateFormat="dateFormat"
                                    :always-show-calendars="false"
                                    :alwaysShowCalendars="alwaysShowCalendars"
                                    class="vs-inputx vs-input--input"
                                >
                                    <div slot="input" slot-scope="picker" style="min-width: 350px;">
                                    {{ picker.startDate | date }} - {{ picker.endDate | date }}
                                    </div>
                                </date-range-picker>
                            </div>
                            <div class="w-1/8 px-2">
                                <vs-button @click="makeSearch()" :disabled="dateRange.startDate === '' && dateRange.endDate === ''" style="margin-top: 18px;" color="primary"
                                            type="filled" icon="search">Recherche
                                </vs-button>
                            </div>
                            <div class="w-1/8 px-2">
                                <vs-button @click="exportStats()" :disabled="dateRange.startDate === '' && dateRange.endDate === ''" style="margin-top: 18px;" color="primary"
                                            type="filled" icon="search">Exporter
                                </vs-button>
                            </div>
                        </div>
                    </vs-col>
                </vs-row>
            </vs-card>
        </div>
        <vs-divider></vs-divider>
        <vs-card>
            <div class="vx-row">
                <div class="vx-col w-full">
                    <template>
                        <vue-apex-charts v-if="!loading" type="bar" height="350" :options="charts.chartOptions"
                            :series="charts.series"></vue-apex-charts>
                    </template>
                </div>
            </div>
        </vs-card>
    </div>
</template>
<script>
import DateRangePicker from 'vue2-daterange-picker';
import 'vue2-daterange-picker/dist/vue2-daterange-picker.css'
import VueApexCharts from 'vue-apexcharts'
import moment from "moment";
export default {
    name : "grapheNature",
    components: { DateRangePicker, VueApexCharts },
    data: () => ({
        charts:{
            series: [],
            chartOptions: {
            colors: ['#008FFA', '#067A2F', '#FF0003', '#FF9F43', '#FFCC00'],
            plotOptions: {
                bar: {
                    horizontal: false,
                    columnWidth: '52%',
                },
            },
            dataLabels: {
                enabled: false
            },
            stroke: {
                show: true,
                width: 2,
                colors: ['transparent']
            },

            xaxis: {
                categories: [
                    'Demande reçus',
                    'Demande traitées',
                    'Demande en cours de traitement',
                    'Demande total en attente',
                    'Demande rejecté'
                ],
            },
            yaxis: {
                title: {
                    text: 'Nombres'
                }
            },
            fill: {
                opacity: 1
            },
            tooltip: {
                    y: {
                        formatter: function (val) {
                            return "Nombres " + val
                        }
                    }
                }
            }
        },
        loading: false,
        categories: [],
        user: 0,
        category: '',
        stats: [],
        requests: [],
        last_page: null,
        page: 1,
        opens: 'center',
        showWeekNumbers: true,
        linkedCalendars: true,
        alwaysShowCalendars: true,
        showDropdowns: true,
        autoApply: false,
        locale: {
            direction: 'ltr',
            format: 'dd/mm/yyyy',
            separator: ' - ',
            applyLabel: 'Appliquer',
            cancelLabel: 'Annuler',
            weekLabel: 'W',
            customRangeLabel: 'Custom Range',
            daysOfWeek: ['Dim', 'Lun', 'Mar', 'Mer', 'Jeu', 'Ven', 'Sam'],
            monthNames: ['Jan', 'Fev', 'Mar', 'Avr', 'Mai', 'Jui', 'Juil', 'Aou', 'Sep', 'Oct', 'Nov', 'Dec'],
            firstDay: 0
        },
        dateRange: {
            startDate: "",
            endDate: "",
        },
    }),
    mounted(){
        this.dateRange.startDate = moment(new Date()).format('YYYY-MM-DD')
        this.dateRange.endDate = moment(new Date()).format('YYYY-MM-DD')
        this.makeSearch()
        this.getCategories()
    },
    methods:{
        updateValues(values) {
            this.dateRange.startDate = moment(values.startDate).format('YYYY-MM-DD');
            this.dateRange.endDate = moment(values.endDate).format('YYYY-MM-DD');
        },

        dateFormat(classes, date) {
            let yesterday = moment().subtract(1, 'day');
            return classes
        },

        getCategories() {
                //this.$vs.loading()
                this.$http.get('/categories-requests?paginate=0').then((response) => {
                this.categories = response.data
                //this.$vs.loading.close()
            }).catch((error) => {
                console.log(error)
                //this.$vs.loading.close()
            })
        },


        async exportStats() {
            this.$vs.loading()
            this.$http.post('/ebu/nature-period?export=1', {
                date_debut: this.dateRange.startDate,
                date_fin: this.dateRange.endDate,
                category: this.category
            }, {
                responseType: 'blob',
            }).then((response) => {
                const url = window.URL.createObjectURL(new Blob([response.data]))
                const link = document.createElement('a')
                //link.href = response.data.file
                link.href = link.href = url
                link.setAttribute('download', 'requestNature.xlsx')
                document.body.appendChild(link)
                link.click()
                this.category = ''
                this.$vs.loading.close()
            }).catch((error) => {
                this.$vs.loading.close()
                if (error.response.status === 401) {
                this.$vs.notify({
                    title: 'Erreur',
                    text: 'Votre session a expiré',
                    color: 'danger',
                    iconPack: 'feather',
                    icon: 'icon-check',
                    position: 'top-right'
                })
                this.$router.push({name: "login"})
                }
            })
        },

        makeSearch(){
            this.$vs.loading()
            this.loading = true
            this.$http.post('/ebu/nature-period?export=0', {
                date_debut: this.dateRange.startDate,
                date_fin: this.dateRange.endDate,
                category: this.category
            }).then((response) => {
                this.charts.chartOptions.xaxis.categories = response.data.categories.length > 0 ? response.data.categories : ['Demande reçus','Demande traitées','Demande en cours de traitement','Demande total en attente','Demande rejectées']
                this.charts.series = response.data.series
                this.category = ''
                this.loading = false
            this.$vs.loading.close()
            }).catch((error) => {
                this.$vs.loading.close()
                this.loading = false
                
            })
        }
    }
}
</script>